import React from 'react';
import { Route, Switch } from 'react-router-dom';

import  ListWorkcenter from './list';
import  EditWorkcenter  from './edit';

function Workcenter({ match }) {
    const { path } = match;
    console.log(999,"hola");
    return (
        <Switch>
            <Route exact path={path} component={ListWorkcenter} />
            <Route path={`${path}/add`} component={EditWorkcenter} />
            <Route path={`${path}/edit/:id`} component={EditWorkcenter} />
        </Switch>
    );
}

export { Workcenter };